import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Filter, CheckCircle, Bell } from 'lucide-react';
import { AlertItem, AlertPriority } from '../components/AlertItem';
export function Alerts() {
  const [filter, setFilter] = useState<'all' | 'critical' | 'warning' | 'info'>('all');
  const alerts = [{
    id: 1,
    title: 'Queda Brusca de Preço',
    description: 'Magazine Luiza reduziu o preço do iPhone 14 em 15% nas últimas 2h.',
    time: '10 min atrás',
    priority: 'critical' as AlertPriority,
    productName: 'iPhone 14 128GB'
  }, {
    id: 2,
    title: 'Concorrente Sem Estoque',
    description: 'Amazon BR está sem estoque para Smart TV Samsung 55". Oportunidade de margem.',
    time: '45 min atrás',
    priority: 'info' as AlertPriority,
    productName: 'Smart TV Samsung 55 4K'
  }, {
    id: 3,
    title: 'Preço Acima do Mercado',
    description: 'Seu preço está 12% acima da média do mercado para a categoria de Monitores.',
    time: '2h atrás',
    priority: 'warning' as AlertPriority,
    productName: 'Monitor Dell 27"'
  }, {
    id: 4,
    title: 'Novo Concorrente Detectado',
    description: 'Kabum começou a vender "Cadeira Gamer X" com preço competitivo.',
    time: '3h atrás',
    priority: 'warning' as AlertPriority,
    productName: 'Cadeira Gamer X'
  }, {
    id: 5,
    title: 'Promoção Relâmpago',
    description: 'Casas Bahia iniciou promoção agressiva em Eletrodomésticos.',
    time: '5h atrás',
    priority: 'critical' as AlertPriority
  }, {
    id: 6,
    title: 'Atualização de Preço',
    description: 'Preço atualizado automaticamente conforme regra de paridade.',
    time: '1d atrás',
    priority: 'info' as AlertPriority,
    productName: 'Geladeira Brastemp'
  }, {
    id: 7,
    title: 'Margem de Lucro Baixa',
    description: 'Produto atingiu margem mínima configurada após cobrir oferta.',
    time: '1d atrás',
    priority: 'critical' as AlertPriority,
    productName: 'Air Fryer Mondial'
  }, {
    id: 8,
    title: 'Tendência de Alta',
    description: 'Categoria de Smartphones apresenta tendência de alta de 3% esta semana.',
    time: '2d atrás',
    priority: 'info' as AlertPriority
  }];
  const filteredAlerts = filter === 'all' ? alerts : alerts.filter(a => a.priority === filter);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} className="max-w-5xl mx-auto" data-id="element-372">
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-8" data-id="element-373">
        <div data-id="element-374">
          <h1 className="text-2xl font-bold text-navy-900" data-id="element-375">
            Central de Alertas
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-376">
            Monitore mudanças críticas no mercado em tempo real
          </p>
        </div>
        <div className="flex items-center space-x-3 mt-4 md:mt-0" data-id="element-377">
          <button className="flex items-center px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm text-slate-600 hover:bg-slate-50" data-id="element-378">
            <CheckCircle className="h-4 w-4 mr-2" data-id="element-379" />
            Marcar todos como lidos
          </button>
          <button className="flex items-center px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm text-slate-600 hover:bg-slate-50" data-id="element-380">
            <Filter className="h-4 w-4 mr-2" data-id="element-381" />
            Configurar Regras
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-382">
        <div className="flex border-b border-slate-200" data-id="element-383">
          {['all', 'critical', 'warning', 'info'].map(tab => <button key={tab} onClick={() => setFilter(tab as any)} className={`px-6 py-4 text-sm font-medium border-b-2 transition-colors capitalize ${filter === tab ? 'border-navy-900 text-navy-900 bg-slate-50' : 'border-transparent text-slate-500 hover:text-navy-700 hover:bg-slate-50'}`} data-id="element-384">
              {tab === 'all' ? 'Todos' : tab === 'critical' ? 'Críticos' : tab === 'warning' ? 'Atenção' : 'Informativo'}
            </button>)}
        </div>

        <div className="p-6 bg-slate-50 min-h-[500px]" data-id="element-385">
          {filteredAlerts.length > 0 ? filteredAlerts.map(alert => <AlertItem key={alert.id} title={alert.title} description={alert.description} time={alert.time} priority={alert.priority} productName={alert.productName} data-id="element-386" />) : <div className="flex flex-col items-center justify-center h-64 text-slate-400" data-id="element-387">
              <Bell className="h-12 w-12 mb-4 opacity-20" data-id="element-388" />
              <p data-id="element-389">Nenhum alerta encontrado nesta categoria.</p>
            </div>}
        </div>
      </div>
    </motion.div>;
}